import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ isLoggedIn, username, onLoginClick }) => {
    const location = useLocation();

    return (
        <header className="bg-blue-600 text-white p-4" id="main-header">
            <nav className="container mx-auto flex justify-between items-center">
                <div className="logo" data-test-id="logo">
                    <h1 className="text-2xl font-bold">QA Test Site</h1>
                </div>
                <div className="nav-links flex items-center space-x-4">
                    <Link
                        to="/"
                        className={`hover:underline ${location.pathname === '/' ? 'active-link' : 'nav-link'}`}
                        id="home-link"
                    >
                        Home
                    </Link>
                    <Link
                        to="/items"
                        className={`hover:underline ${location.pathname === '/items' ? 'active-link' : 'nav-link'}`}
                        id="items-link"
                    >
                        Track your Travel
                    </Link>

                    {isLoggedIn ? (
                        <Link
                            to="/my-account"
                            className={`hover:underline ${location.pathname === '/my-account' ? 'active-link' : 'nav-link'}`}
                            id="my-account-link"
                            data-test-id="my-account-link"
                        >
                            My Account
                        </Link>
                    ) : (
                        <button
                            onClick={onLoginClick}
                            className="bg-blue-500 hover:bg-blue-400 px-4 py-2 rounded transition-colors duration-200 login-button"
                            id="login-btn"
                            data-test-id="login-button"
                        >
                            Login
                        </button>
                    )}
                </div>
            </nav>
        </header>
    );
};

export default Header;